import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=76b831aa&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=76b831aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b831aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b831aa')) {
      api.createRecord('76b831aa', component.options)
    } else {
      api.reload('76b831aa', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=76b831aa&scoped=true", function () {
      api.rerender('76b831aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/aside/Menu.vue"
export default component.exports